module.exports = __webpack_public_path__ + "static/media/Funds.d66e9e3e.png";